import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import TimeField from '../TimeField'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
}

/**
 * Connects the TimeField with Formik
 */
function FormikTimeField(props) {
  const { id } = props

  return (
    <Field name={id}>
      {({ field, meta }) => (
        <TimeField
          {...props}
          id={id}
          name={id}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={field.value}
          errors={meta.touched && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikTimeField.propTypes = propTypes

export default FormikTimeField
